import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Spin } from 'antd';

import { spinDelay } from 'constants/defaults';
import ErrorHTML from 'components/common/form/ErrorHTML';
import SidebarHeader from './SidebarHeader';

export default class SidebarContainer extends Component {
    static propTypes = {
        meta: PropTypes.object.isRequired,
        refresh: PropTypes.func,
        title: PropTypes.node,
        children: PropTypes.node,
        footer: PropTypes.node,
        headerModal: PropTypes.object,
        disableLock: PropTypes.bool
    };

    render() {
        const { meta, refresh, title, children, footer, disableLock, headerModal } = this.props;

        return (
            <div className="right-sidebar-wrap">
                <SidebarHeader disableLock={disableLock} modal={headerModal} title={title}>
                    { title }
                </SidebarHeader>

                <div className={cx('right-sidebar-overflow', {'has-footer': footer})}>
                    <ErrorHTML meta={meta} refresh={refresh} />
                    <Spin spinning={meta.pending} delay={spinDelay}>
                        { !meta.error && children }
                    </Spin>
                </div>

                { footer && (
                    <div className="right-sidebar-footer">
                        {footer}
                    </div>
                )}
            </div>
        );
    }
}
